<template>
    <span :class="{
        'redbox': old, 'bluebox': !old && !outlined, 'outlinedbox': !old && outlined,
        'text-white': !outlined || old, 'boxed pit-mono ma-1': true,
    }">{{ rev }}</span>
</template>
<style scoped>
.boxed {
    font-size: 0.7em;
    border-radius: 2px;
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 2px;
    padding-right: 2px;
}

.redbox {
    background-color: rgba(253, 0, 0, 0.463);

}

.bluebox {
    background-color: rgba(42, 163, 255, 0.696);

}

/* Inside a coloured button: the button's own colour, so the box does not
   bring a second one into it. */
.outlinedbox {
    border: 1px solid currentColor;
    padding-top: 0;
    padding-bottom: 0;
}
</style>
<script>
export default {
    // `outlined`: drawn in the colour around it, for a revision inside a
    // coloured link button. An old revision stays red either way.
    props: {
        rev: { default: null },
        old: { default: false },
        outlined: { type: Boolean, default: false },
    },
}
</script>
